import { createAPIActions } from 'utils/common';

import {
  CreateArrangementPayload,
  SavedArrangement,
  UpdateArrangementPayload,
} from './saved_arrangements.types';

const getAll = createAPIActions<void, SavedArrangement[]>('savedArrangements', 'getAll');
const create = createAPIActions<CreateArrangementPayload, SavedArrangement>(
  'savedArrangements',
  'create'
);
const update = createAPIActions<UpdateArrangementPayload, SavedArrangement>(
  'savedArrangements',
  'update'
);
const destroy = createAPIActions<number, number>('savedArrangements', 'destroy');

export default {
  getAll,
  create,
  update,
  destroy,
};
